import { request } from './request'

// 邮件模板/邮件搜索
export interface GetEmail {
  limit: number
  page: number
  name?: string
  origin_type?: number
  email_type?: number
  attck_name?: string[]
}
// export const getEmail = (data: GetEmail) =>
//   request('/portal/verify/phish/resource/template/email', {
//     params: {
//       ...data,
//     },
//   })
export const getEmail = (data: GetEmail) =>
  request('/portal/verify/phish/resource/template/email/list', {
    method: 'post',
    data: {
      ...data,
    },
  })

export const getEmailAttck = () =>
  request('/portal/verify/phish/resource/template/email/attck/option')

// 邮件自定义删除
export interface DelPages {
  id: number
}
export const delPages = (data: DelPages) =>
  request('/phishapi/pages/del', {
    method: 'post',
    data: {
      ...data,
    },
  })
// 钓鱼模板
export interface GetPhishingPages {
  limit: number
  page: number
  name?: string
  origin_type?: number
  autocommit?: number
  attck_name?: string[]
}
// export const getPhishingPages = (data: GetPhishingPages) =>
//   request('/portal/verify/phish/resource/template/page', {
//     params: {
//       ...data,
//     },
//   })

export const getPhishingPages = (data: GetPhishingPages) =>
  request('/portal/verify/phish/resource/template/page/list', {
    method: 'post',
    data: {
      ...data,
    },
  })

export const getPhishAttck = () =>
  request('/portal/verify/phish/resource/template/page/attck/option')

// 附件模板
export interface GetAttachments {
  limit: number
  page: number
  name?: string
  origin_type?: number
  attachment_type?: number
}
// export const getAttachments = (data: GetAttachments) =>
//   request('/portal/verify/phish/resource/template/attachment', {
//     params: {
//       ...data,
//     },
//   })
export const getAttachments = (data: GetAttachments) =>
  request('/portal/verify/phish/resource/template/attachment/list', {
    method: 'post',
    data: {
      ...data,
    },
  })
export const getAttachmentAttck = () =>
  request('/portal/verify/phish/resource/template/attachment/attck/option')
// 附件模板下载
export interface GetAttachmentsDownload {
  template_id: string
}
export const getAttachmentsDownload = (data: GetAttachmentsDownload) =>
  request('/portal/verify/phish/resource/template/attachment/download', {
    responseType: 'arraybuffer',
    headers: { 'Content-Transfer-Encoding': 'binary' },
    params: {
      ...data,
    },
  })
// 获取最佳搭配
export interface GetGood {
  email_type: number
  template_id: string
}
export const getGood = (data: GetGood) =>
  request('/portal/verify/phish/resource/template/good', {
    params: {
      ...data,
    },
  })

// 获取邮件模板
export interface GetEmailDetail {
  id: number
}
export const getEmailDetail = (data: GetEmailDetail) =>
  request('/portal/verify/phish/campaign/template/detail', {
    params: {
      ...data,
    },
  })
// 添加自定义邮件模板
export interface CreateTemplate {
  name: string
  subject: string
  content: string
  email_type: number
  sender?: string
  template_id?: number
  cover: string
  link: string[]
}
export const createTemplate = (data: CreateTemplate) =>
  request('/portal/verify/phish/resource/template/email', {
    method: 'post',
    data: {
      ...data,
    },
  })
// 删除自定义邮件模板
export interface DelEmail {
  id: number
}
export const delEmail = (data: DelEmail) =>
  request('/portal/verify/phish/resource/template/email', {
    method: 'DELETE',
    data: {
      ...data,
    },
  })
// 修改自定义邮件模板
export interface PutEmail {
  id: number
  name: string
  subject: string
  content: string
  email_type: number
  sender?: string
  template_id?: number
  cover: string
  link: string[]
}
export const putEmail = (data: PutEmail) =>
  request('/portal/verify/phish/resource/template/email', {
    method: 'put',
    data: {
      ...data,
    },
  })

// 获取自定义邮件模板详情
export interface GetDetail {
  id: number
}
export const getDetail = (data: GetDetail) =>
  request('/portal/verify/phish/resource/template/email/detail', {
    params: {
      ...data,
    },
  })

// 添加自定义钓鱼模板
export interface CreatePhishTemplate {
  name: string
  content: string
  redirect: string
  autocommit: number
  cover: string
  security_id: string
}
export const createPhishTemplate = (data: CreatePhishTemplate) =>
  request('/portal/verify/phish/resource/template/page', {
    method: 'post',
    data: {
      ...data,
    },
  })
// 删除自定义钓鱼模板
export interface DelPhishEmail {
  id: number
}
export const delPhishEmail = (data: DelPhishEmail) =>
  request('/portal/verify/phish/resource/template/page', {
    method: 'DELETE',
    data: {
      ...data,
    },
  })
// 修改自定义钓鱼模板
export interface PutPhishEmail {
  id: number
  name: string
  content: string
  redirect: string
  autocommit: number
  security_id: string
}
export const putPhishEmail = (data: PutPhishEmail) =>
  request('/portal/verify/phish/resource/template/page', {
    method: 'put',
    data: {
      ...data,
    },
  })

// 获取自定义钓鱼模板详情
export interface GetPhishDetail {
  id: number
}
export const getPhishDetail = (data: GetPhishDetail) =>
  request('/portal/verify/phish/resource/template/page/detail', {
    params: {
      ...data,
    },
  })

// 添加自定义钓鱼模板

export const createAttachmentDetail = data =>
  request('/portal/verify/phish/resource/template/attachment', {
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart / form - data',
    },
  })
// 删除自定义钓鱼模板
export interface DelAttachmentDetail {
  id: number
}
export const delAttachmentDetail = (data: DelAttachmentDetail) =>
  request('/portal/verify/phish/resource/template/attachment', {
    method: 'DELETE',
    data: {
      ...data,
    },
  })
// 修改自定义钓鱼模板

export interface PutAttachmentName {
  id: string
  attachment_name: string
  old_attachment_name: string
}
export const putAttachmentName = (data: PutAttachmentName) =>
  request('/portal/verify/phish/resource/template/attachment/name', {
    method: 'PUT',
    data,
  })

// 获取自定义钓鱼模板详情
export interface GetAttachmentDetail {
  id: number
}
export const getAttachmentDetail = (data: GetAttachmentDetail) =>
  request('/portal/verify/phish/resource/template/attachment/detail', {
    params: {
      ...data,
    },
  })
// 克隆页面
export interface CloneHtml {
  url: string
}
export const cloneHtml = (data: CloneHtml) =>
  request('/portal/verify/phish/resource/template/html', {
    params: {
      ...data,
    },
  })

export interface GetEducationTemplateList {
  limit?: number
  page?: number
  keyword?: string
}
// 获取安全教育模板列表
export const getEducationTemplateList = (data: GetEducationTemplateList) =>
  request('/portal/verify/phish/resource/template/security', {
    params: {
      ...data,
    },
  })
